var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-description-text',{attrs:{"background":"#f5f5f5","max-width":"700px","description":_vm.documentToHtmlString(_vm.translations.signallerParagraph)}})}
var staticRenderFns = []

export { render, staticRenderFns }